import React, { FC } from "react";
import { useFormState } from "react-final-form";
import { IWizardStepContent } from "../../../../wizard/types";
import { IViewAcademicListItemSecondary } from "../../../types";
import { ViewAcademic } from "../../components/ViewAcademic";

const Content: FC<IWizardStepContent> = ({ handleSubmit }) => {
  const {
    values: {
      injectedData: { data },
    },
  }: { values: { injectedData: { data: IViewAcademicListItemSecondary } } } =
    useFormState(); // todo

  return (
    <form noValidate onSubmit={handleSubmit}>
      <ViewAcademic
        schoolLevelName={data.levelName}
        schoolTypeName={data.schoolTypeName}
        schoolGrade={data.grade}
        requiredDocuments={data.requiredDocs}
        applicationForms={data.applicationForms}
        applicationLink={data.applicationLink}
      />
    </form>
  );
};

export default Content;
